import { render, staticRenderFns } from "./footersXQ.vue?vue&type=template&id=4d05c73b&scoped=true"
import script from "./footersXQ.vue?vue&type=script&lang=js"
export * from "./footersXQ.vue?vue&type=script&lang=js"
import style0 from "./footersXQ.vue?vue&type=style&index=0&id=4d05c73b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d05c73b",
  null
  
)

export default component.exports